import styled from 'styled-components';

interface MarkerProps {
  name: string;
  id: number;
}
const AreaMarker = ({ name, id }: MarkerProps) => {
  return <Container>{name}</Container>;
};

const Container = styled.div`
  background-color: #fff;
  padding: 4px 16px;
  border-radius: 360px;
  font-size: 12px;
  font-family: materialMedium;
  color: black;
`;
export default AreaMarker;
